var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "material-receive-list" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.subTabClick },
          model: {
            value: _vm.subActiveName,
            callback: function ($$v) {
              _vm.subActiveName = $$v
            },
            expression: "subActiveName",
          },
        },
        _vm._l(_vm.subTabs, function (tab, index) {
          return _vm.$hasBtnRoles(tab.permission)
            ? _c(
                "el-tab-pane",
                { key: index, attrs: { label: tab.label, name: tab.name } },
                [
                  _vm.subActiveName === tab.name
                    ? _c(
                        tab.component,
                        _vm._b(
                          {
                            ref: tab.component,
                            refInFor: true,
                            tag: "component",
                            attrs: { type: _vm.type },
                            on: {
                              gotoMaterialReceive:
                                _vm.handleGotoMaterialReceive,
                            },
                          },
                          "component",
                          tab.name === "2" && _vm.materialReceiveCode
                            ? { initCode: _vm.materialReceiveCode }
                            : {},
                          false
                        )
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e()
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }